import { tns } from "tiny-slider";

jQuery(function($) {

    // Tabs on product page
    function product_tabs(){

        const productTabs = document.querySelectorAll('.product-tab');
        
        if(productTabs){
            productTabs.forEach( tab => tab.querySelector('button').addEventListener('click', () => tab.classList.toggle('active') ))
        }

    }
    product_tabs();

     // Product image gallery
    // if( document.getElementsByClassName('flex-control-nav').length ){
    //     let product_slider = tns({
    //         container: '.flex-control-nav',
    //         items: 3,
    //         gutter: 14,
    //         controls: true,
    //         controlsPosition: "bottom",
    //         nav: false,
    //         controlsText: [ 
    //             '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M18.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L35.3 256 245.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-216 216z"/></svg>', 
    //             '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M301.7 250.3c3.1 3.1 3.1 8.2 0 11.3l-216 216c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L284.7 256 74.3 45.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l216 216z"/></svg>'
    //         ],
    //         loop: false,
    //         rewind: true
    //     });
    // }

    // places zoom toggle at the bottom of the image
    // Let woo set the gallery height first and grab the value
    setTimeout( () => {
        
        const gallery = document.querySelector('.gallery');
        const flex_viewport = gallery.querySelector('.flex-viewport');
        const magnifyingIcon = document.querySelector('.woocommerce-product-gallery__trigger');

        if( gallery && flex_viewport ){
            const height = flex_viewport.style.height;
            magnifyingIcon.style.top = height;
        }

    } ,300)



    // Product gallery

    var $gallery = $('.woocommerce-product-gallery');

    if( $gallery.find('.woocommerce-product-gallery__wrapper > div').length > 1 ){

        // Add custom buttons (only if not already added)
        if ($gallery.find('.custom-nav').length === 0) {
            $gallery.find('.woocommerce-product-gallery__wrapper').append('<button class="flex-prev custom-nav"><svg xmlns="http://www.w3.org/2000/svg" height="14" width="8.75" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M9.4 256l11.3-11.3 192-192L224 41.4 246.6 64 235.3 75.3 54.6 256 235.3 436.7 246.6 448 224 470.6l-11.3-11.3-192-192L9.4 256z"/></svg></button><button class="flex-next custom-nav"><svg xmlns="http://www.w3.org/2000/svg" height="14" width="8.75" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M310.6 256l-11.3 11.3-192 192L96 470.6 73.4 448l11.3-11.3L265.4 256 84.7 75.3 73.4 64 96 41.4l11.3 11.3 192 192L310.6 256z"/></svg></button>');
        }

        // Wait until FlexSlider is initialized by WooCommerce
        $gallery.on('init', function(event, slider) {
            // Bind click events to the custom buttons
            $('.flex-prev').on('click', function() {
                slider.flexslider('prev');
            });
            $('.flex-next').on('click', function() {
                slider.flexslider('next');
            });
        });

        setTimeout(function() {
            
            var slider = $('.woocommerce-product-gallery').data('flexslider');
    
            if (slider) {
    
                // makes it 2 cols if more than 8 images
                if( slider.slides.length > 8 ){
                    slider[0].classList.add('columns-2');
                }
    
                $('.flex-prev').on('click', function() {
                    slider.flexslider('prev');
                });
    
                $('.flex-next').on('click', function() {
                    slider.flexslider('next');
                });
    
            }
    
        }, 500); // Adjust timing if necessary
    }
});